<div class="snackbar">
    <div class="icon-wrap">
        @if(data.success) {
            <span class="success"><mat-icon fontIcon="check_circle"></mat-icon></span>
        } @else {
            <span class="error"><mat-icon fontIcon="error"></mat-icon></span>
        }
        <span class="message">{{data.message | translate}}</span>
    </div>
   <div>
      <!-- @if(data.action && data.action === 'login') {
           <span matSnackBarActions><button mat-raised-button (click)="login()">{{'button.login' | translate}}</button></span>
       } -->
   </div>
</div>
